import { render, staticRenderFns } from "./PostListItem.vue?vue&type=template&id=5344d183&scoped=true&"
import script from "./PostListItem.vue?vue&type=script&lang=js&"
export * from "./PostListItem.vue?vue&type=script&lang=js&"
import style0 from "./PostListItem.vue?vue&type=style&index=0&id=5344d183&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5344d183",
  null
  
)

export default component.exports